<template>
    <main id="mainCtrl">
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" v-cloak>
                <li :class="{'active': defaultFilter.type === 'new'}" @click.stop.prevent="load('new')" id="tabNew"><a
                    href="#">Новые</a></li>
                <li :class="{'active': defaultFilter.type === 'published'}" @click.stop.prevent="load('published')"
                    id="tabPublished"><a href="#">Опубликованные</a></li>
                <li :class="{'active': defaultFilter.type === 'unpublished'}" @click.stop.prevent="load('unpublished')"
                    id="tabUnpublished"><a href="#">Неопубликованные</a></li>
            </ul>
        </div>
        <v-table
            id="mainTbl"
            :default-filter="defaultFilter"
            request-uri="reviewComments/getList"
            pagesize="50"
            ref="table"
            :show-eye="false"
            @updated="setReviewCommentsHeight"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="reviewee_name">
                        Врач / Клиника
                    </v-th>
                    <v-th name="author_type">
                        Автор
                    </v-th>
                    <v-th name="text">
                        Текст ответа
                    </v-th>
                    <v-th name="moderator">
                        Проверил
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="reviewee_name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="author_type" v-slot="{filter}">
                        <v-select v-model="filter.value" :options='[
                            {value: "", text: "\u00a0"},
                            {value: "PATIENT", text: "Пациент"},
                            {value: "DOCTOR_SITE", text: "Врач"},
                            {value: "CLINIC", text: "Клиника"},
                            {value: "NETWORK", text: "Сеть"},
                        ]'/>
                    </v-th>

                    <v-th name="text" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="moderator" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...userOptions.map(({text, value}) => {
                                    return {
                                        text,
                                        value
                                    }
                                })
                            ]'
                        />
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr>
                    <v-td>
                        <ReviewComment :key="index"
                                       :item="item"
                                       :status="defaultFilter.type"
                                       @update-table="update"
                                       :urls-frontend="urlsFrontend"/>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import ReviewComment from "./ReviewComment";
import NewPublishedUnpublishedSwitcher from "@mixins/NewPublishedUnpublishedSwitcher";
export default {
    props: {
        userOptions: {
            type: Array,
            required: true
        },
        urlsFrontend: {
            type: String,
            required: true
        }
    },
    components: {ReviewComment},
    mixins: [NewPublishedUnpublishedSwitcher],
    methods: {
        update: function (data, btn = null) {
            this.$refs.table.update();
        },
        setReviewCommentsHeight() {
            setTimeout(() => {
                document.querySelectorAll('.review-comment-text').forEach(el => {
                    el.style.height = '45px';
                    el.style.height = 5 + el.scrollHeight + 'px';
                })
            }, 100)
        }
    },
}
</script>

<style>
    main#mainCtrl #mainTbl .vuetable > .inner > table:nth-child(2) > tbody > tr {
        background-color: rgba(255, 255, 255, 0.5);
    }
</style>
